import React, { useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import Send from "../../../../../../images/Finalize.svg";
import ConfirmationImage from "../../../../../../images/Confirmation.svg";
import Success from "./Success";
import { useNavigate } from "react-router-dom";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const Confirmation = ({ setModalFlag }: Props) => {
    const navigate=useNavigate()
  return (
    <>
      <div className="quotation__confirmation">
            <img
              src={ConfirmationImage}
              alt=""
              className="quotation__confirmation--image"
            />
            <Title>Confirmation</Title>
            <div className="quotation__confirmation--text">
              Are you sure you want to continue finalizing the Quotation Form
            </div>
            <div className="quotation__confirmation--buttons">
              <button
                className="quotation__confirmation--buttons--send"
                onClick={() =>navigate(`/quotationform/success`)}
              >
                <img src={Send} alt="" /> Submit
              </button>
              <button className="quotation__confirmation--buttons--cancel">
                <img src={Close} alt="" onClick={() => setModalFlag(false)} />
                Cancel
              </button>
            </div>
        
      </div>
    </>
  );
};

export default Confirmation;
